/**
 * Forwarder credentials are write-only (CASA 7.3.2, PR #740 round 3).
 *
 * Form reads return every stored credential (GHL token, bearer token, API-key
 * header value, basic-auth password, custom header values) as STORED_CREDENTIAL
 * and list the masked paths in `credentials_set`. Saving STORED_CREDENTIAL, an
 * empty value or omitting the field keeps what the server holds; typing a new
 * value replaces it. Mirrors backend services/forwarder_credentials.py.
 */
export const STORED_CREDENTIAL = '********';

export function isStoredCredential(value) {
    return value === STORED_CREDENTIAL;
}
